module.exports = require("accounting");


//////////////////
// WEBPACK FOOTER
// external "accounting"
// module id = 12
// module chunks = 0